import Vue, { RenderContext } from 'vue';
import { mergeData } from 'vue-functional-data-merge';

export const props = {
    fluid: {
        type: [Boolean, String],
        default: false
    }
};

export const TContainer = Vue.extend({
    name: 'TContainer',
    functional: true,
    props,
    render(h: any, { props, children, data }: RenderContext) {
        return h(
            'div',
            mergeData(data, {
                class: {
                    container: !(props.fluid || props.fluid === ''),
                    'container --fluid': props.fluid === true || props.fluid === ''
                }
            }),
            children
        );
    }
});
